import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import type { Store } from 'antd/es/form/interface';

import type { Hotel } from 'app/typings/hotels/Hotel/Hotel';

type BarBBProps = {
  openBarBbModal: boolean;
  setOpenBarBbModal: (open: boolean) => void;
  values: Hotel;
  setFieldsValue: (value: Store) => void;
};

export const BarBBModal = ({
  openBarBbModal,
  setOpenBarBbModal,
  values,
  setFieldsValue,
}: BarBBProps) => {
  const handleOk = () => {
    setFieldsValue({ ...values, connectedBarBb: true });
    setOpenBarBbModal(false);
  };

  return (
    <Modal
      key="bar-bb-modal"
      title={
        <>
          <ExclamationCircleOutlined
            style={{ color: '#FF382C', marginRight: 8 }}
          />
          Configuration warning
        </>
      }
      open={openBarBbModal}
      footer={[
        <Button key="ok" type="primary" onClick={handleOk}>
          Ok
        </Button>,
      ]}
      closable={false}
    >
      <p>
        Mapping a BAR rate that includes breakfast (BAR BB) is not recommended
        under our current guidelines.
      </p>
      <br />
      <p>
        As a result, this hotel will only be able to sell night stays for 2
        adults. All night stay packages will be restricted to a maximum and a
        minimum occupancy of 2 adults.
      </p>
    </Modal>
  );
};
